import React, { useEffect, useState } from 'react'
import { useQuery, useMutation } from 'react-query';
import { GetCacheKey } from "../../../services/common/utils";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { callQueryapi } from "../../../services/http/callapi";
import AllRoamingCountries from "./roamingCountries";
import AllRoamingPacks from "./roamingPacks";
import { useTranslation } from 'react-i18next';
import RoamingPackCountriesShimmer from '../../../ShimmerEffect/RoamingPackCountriesShimmer';
function RoamingPacksCountries({ pmsitem , bgcolor}) {
  const [tabs, setTabs] = useState([]);
  const [key, setKey] = useState('41362');
  const [search, setSearch] = useState("");
  const [allCountriesKey, setAllCountriesKey] = useState('')
  const {t} = useTranslation();
  const {
    data: { data } = {},
    isLoading,
    isFetching,
    error
  } = useQuery([GetCacheKey("roamingPacks"), pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}],
    {
      retry: false,
      retryOnMount: false,

      onSuccess: ({data: udata})=>{
        if(udata?.status === "0"){
          setTabs(udata?.data?.map(item => item?.elementmeta?.title));
          setKey(udata?.data?.map(item => item?.elementmeta?.title)?.[0]);
          setAllCountriesKey(udata?.data?.map(item => item?.elementmeta?.title)?.[0]);
        }
      }
    });

    const handleSearch = (e) =>{
      let validString  = e.target.value.replace(
        /[`\~!@#$%^&*()_|+\-=?;•√π÷×¶∆£¢€¥°©®™✓:'",.<> \{\}\[\]\\\/]/g,
        '');
        validString = validString.replace('‘', '');
        validString = validString.replace('“', '');
        setSearch(validString)
    }
    if(isLoading || isFetching){
      return <RoamingPackCountriesShimmer/>
    }

  return (
    <>
    {data ?.data &&
    <>


        <div class="position-relative category-tabs ">
          { (key === allCountriesKey ) &&
            <section class="corp-abt-thumb-slider pack-tab-swiper borderradius-bg">
              <div class="pse_sm">
                <div class="flex_grp_align_center search_input_grp mt-3">
                    <div class="input_icon_search input_icon_search-v1 left-icon flex1">
                        <input 
                          type="text"
                          onChange={handleSearch}
                          maxlength='30' 
                          value={search}
                          className="form-control" 
                          placeholder={t("searchcoutries")}
                          data-bs-toggle="offcanvas" 
                          data-bs-target="#search-results"
                          aria-controls="offcanvasBottom" 
                        />
                        <button class='pe-none'>
                            <img 
                                src={process.env.PUBLIC_URL + "/assets/images/search_dark.svg"}
                                alt=""
                                title=""
                            />
                        </button>
                    </div>
                </div>
              </div>
            </section>
          }
          <div class="container-tab position-relative">
          <div class="swiper-container tabs-thumbs c-about-thumbs">
              <Tabs
                // defaultActiveKey={}
                onSelect={(k) =>setKey(k)}
                transition={true} id="uncontrolled-tab-example" className="cs_tabs white-bg m-0 box-shadow-comp" >
                {data?.data?.map(res => {
                  return(
                    <Tab eventKey={res?.elementmeta ?.title} title={res?.elementmeta ?.title}>
                      {res?.templatetype === "320" ? <AllRoamingCountries pmsitem={res} search={search} bgcolor={bgcolor}/> : <AllRoamingPacks pmsitem={res}/>}
                    </Tab>
                  )}
                )}
              </Tabs>
            </div>
          </div>
        </div>
        
        </>
      }
    </>
  )
}

export default RoamingPacksCountries
